import(/* webpackMode: "eager", webpackExports: ["NotFoundView"] */ "/app/src/features/not-found/ui/views/not-found-view.jsx");
